import Box from "ds/components/Box";

import AssistantPanelLayoutHeader from "../Layout/Header";
import AssistantPanelLayoutHeaderActions from "../Layout/Header/Actions";

const AssistantPanelChatSimpleHeader = () => {
  return (
    <AssistantPanelLayoutHeader>
      <Box grow="1" justify="end">
        <AssistantPanelLayoutHeaderActions />
      </Box>
    </AssistantPanelLayoutHeader>
  );
};

export default AssistantPanelChatSimpleHeader;
